import { create } from "zustand";
import {
  getCityApi,
  getDepartmentApi,
  getDivisionApi,
  getStateApi,
  getTriggerListApi,
  getVendorProfileApi,
  sendReminderApi,
  vendorGeneralInfoSubmitApi,
  vendorSaveApi,
  getVendorDetailByGUIDApi,
  getApprovedStatusApi,
  getVendorListApi,
  approveApplicationApi,
  rejectApplicationApi,
  getBusinessTypeApi,
  getCategoryByUserIdApi,
  getVendorReportsApi,
  getVendorStatusReportApi,
} from "../services/vendorMaster";
import { useGenralInfoFormStore } from "./vendorRegistrationStore/useGeneralInfoFormStore";
import { useBasicDataFormStore } from "./vendorRegistrationStore/useBasicDataFormStore";
import { useCommercialStore } from "./vendorRegistrationStore/useCommercialStore";
import { useTradeStore } from "./vendorRegistrationStore/useTradeStore";
import { useDocumentStore } from "./vendorRegistrationStore/useDocumentStore";

const getVendorGUID = () => localStorage.getItem("vendorGUID");
export const useVendorMasterStore = create((set) => ({
  division: [],
  department: [],
  triggerList: [],
  state: [],
  city: [],
  genralInfo: null,
  basicInfo: null,
  triggerVendor: null,
  loading: false,
  triggerVendor: null,
  vendorProfiles: [],
  vendorDetailByGuid: null,
  approvedStatus: [],
  vendorLists: [],
  vendorReports: [],
  businessType: [],
  category: [],
  editInStep4: false,
  checkBoxes: {
    generalInfo: false,
    registeredHo: false,
    // priceAndMargin: false,
    // totAgreement: false,
    taxDetails: false,
    address: false,
    creditTerms: false,
    paymentInsAndMethods: false,
    totIncentives: false,
    last3YearTurnover: false,
    document: false,
    damageAndExpiry: false,
  },
  // Setter
  setEditInStep4: (data) => set({ editInStep4: data }),
  setCheckbox: (field, value) => {
    set((state) => ({
      checkBoxes: {
        ...state.checkBoxes,
        [field]: value,
      },
    }));
  },
  setAllCheckboxes: (value) =>
    set({
      checkBoxes: {
        generalInfo: value,
        registeredHo: value,
        // priceAndMargin: value,
        // totAgreement: value,
        taxDetails: value,
        address: value,
        creditTerms: value,
        paymentInsAndMethods: value,
        totIncentives: value,
        last3YearTurnover: value,
        document: value,
        damageAndExpiry: value,
      },
    }),
  setLoading: (value) => set({ loading: value }),
  // Actions
  getDivision: async (from, to) => {
    set({ loading: true });
    try {
      const response = await getDivisionApi(from, to);
      set({ division: response?.Data || [] });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
      set({ division: [] });
    } finally {
      set({ loading: false });
    }
  },
  getCategory: async () => {
    set({ loading: true });
    try {
      const response = await getCategoryByUserIdApi();
      set({ category: response?.Data || [] });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
      set({ category: [] });
    } finally {
      set({ loading: false });
    }
  },
  getDepartment: async (id) => {
    try {
      const response = await getDepartmentApi(id);
      set({ department: response?.Data || [] });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    }
  },
  getTriggerList: async () => {
    set({ loading: true });
    try {
      const response = await getTriggerListApi();
      const formattedData = response?.Data.map((element, index) => ({
        ...element,
        serialNo: index + 1,
      }));
      set({ triggerList: formattedData || [] });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    } finally {
      set({ loading: false });
    }
  },
  getState: async (id) => {
    try {
      const response = await getStateApi(id);
      set({ state: response?.Data });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    }
  },
  getCity: async (id) => {
    try {
      const response = await getCityApi(id);
      set({ city: response?.Data });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    }
  },
  submitGenralInfo: async (form) => {
    set({ loading: true });
    try {
      const response = await vendorGeneralInfoSubmitApi(form);
      set({ genralInfo: response?.Data });
      return response?.Data[0];
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    } finally {
      set({ loading: false });
    }
  },
  triggerVendorSave: async (form) => {
    try {
      const response = await vendorSaveApi(form);
      set({ triggerVendor: response?.Data });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    }
  },
  sendReminder: async (id) => {
    try {
      const response = await sendReminderApi(id);
      return response;
      // set({ triggerVendor: response?.Data });
    } catch (error) {
      throw new Error(error);
    }
  },

  getVendorProfile: async () => {
    set({ loading: true });
    try {
      const response = await getVendorProfileApi();
      const formattedData = response?.Data?.map((element, index) => ({
        ...element,
        serialNo: index + 1,
      }));
      set({ vendorProfiles: formattedData || [] });
    } catch (error) {
      throw new Error(error);
    } finally {
      set({ loading: false });
    }
  },
  getVendorLists: async (status, from, to) => {
    set({ loading: true });
    try {
      const response = await getVendorListApi(status, from, to);
      const formattedData = response?.Data?.map((element, index) => ({
        ...element,
        serialNo: index + 1,
      }));
      set({ vendorLists: formattedData || [] });
    } catch (error) {
      throw new Error(error);
    } finally {
      set({ loading: false });
    }
  },

  getVendorReports: async (from, to) => {
    set({ loading: true });
    try {
      const response = await getVendorReportsApi(from, to);
      const formattedData = response?.Data?.map((element, index) => ({
        ...element,
        serialNo: index + 1,
      }));
      set({ vendorReports: formattedData || [] });
    } catch (error) {
      throw new Error(error);
    } finally {
      set({ loading: false });
    }
  },

  getApprovedStatus: async (id) => {
    try {
      const response = await getApprovedStatusApi(id);
      set({ approvedStatus: response?.Data || [] });
    } catch (error) {
      throw new Error(error);
    }
  },

  getVendorStatusReport: async (id) => {
    try {
      const response = await getVendorStatusReportApi(id);
      set({ approvedStatus: response?.Data || [] });
    } catch (error) {
      throw new Error(error);
    }
  },

  getVendorDetailByGuid: async (id) => {
    try {
      const response = await getVendorDetailByGUIDApi(id);
      const { Vendor, GeneralInformation, BasicData } = response.Data;
      useGenralInfoFormStore
        .getState()
        .setVendorFromApi(GeneralInformation, Vendor);
      useBasicDataFormStore.getState().setBasicDataApi(BasicData);
      useCommercialStore
        .getState()
        .setCommercialApi(BasicData?.VendorCommercialTermsDto[0]);
      useTradeStore.getState().setTradeApi(BasicData.TradeSupportTermsDto[0]);
      useDocumentStore
        .getState()
        .setDocumentsFromApi(BasicData.VendorDocumentsDto[0]);
      set({ vendorDetailByGuid: response?.Data || [] });
    } catch (error) {
      throw new Error(error);
    }
  },

  approveVendor: async (approvalRemark = "") => {
    set({ loading: true });
    try {
      const payload = {
        vendorGUID: getVendorGUID(),
        approvalRemark,
      };

      const response = await approveApplicationApi(payload);

      return response;
    } catch (error) {
      throw error;
    } finally {
      set({ loading: false });
    }
  },

  rejectVendor: async (approvalRemark = "") => {
    set({ loading: true });
    try {
      const payload = {
        vendorGUID: getVendorGUID(),
        approvalRemark,
      };

      const response = await rejectApplicationApi(payload);

      return response;
    } catch (error) {
      throw error;
    } finally {
      set({ loading: false });
    }
  },
  getBusinessType: async () => {
    try {
      const response = await getBusinessTypeApi();
      set({ businessType: response?.Data || [] });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    }
  },

  reset: () => set({ count: 0 }),
}));
